<template>
  <el-card class="box-card form-screen mb-50 form-contact" v-if="!showConfirmScreen">
    <el-row>
      <el-col :span="24">
        <el-form :rules="rules" :model="form" ref="form">
          <p class="title">
            <span class="font-weight-700">{{ $t('contacts.form.from') }}</span><br>
            <span>{{ $t('contacts.form.from_admin') }}</span>
          </p>
          <el-form-item prop="contact_category_id" :error="getErrorForField('contact_category_id', errors)" class="input-size-380">
            <label slot="label" class="el-form-item__label">{{ $t('contacts.form.input_labels.contact_category_id') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-select
              v-model="form.contact_category_id"
              :placeholder="$t('contacts.form.input_placeholder.contact_category_id')"
              @blur="validateSelect('contact_category_id')"
              @change="$refs['form'].clearValidate('contact_category_id')"
            >
              <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="content" :error="getErrorForField('content', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('contacts.form.input_labels.content') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input
              name="content"
              v-model="form.content"
              :placeholder="$t('contacts.form.input_placeholder.content')"
              type="textarea"
              class="textarea h-630"
              @blur="() => { form.content = form.content.trim()}"
            >
            </el-input>
          </el-form-item>
          <el-form-item class="btn-container mt-25 text-left">
            <el-button type="primary" @click="confirm('form')" class="btn btn-submit btn-w157">{{ $t('contacts.form.buttons.confirm') }}</el-button>
            <el-button @click="back" class="btn btn-back btn-w157">{{ $t('back') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
  <el-card class="box-card confirm-contact-screen" v-if="showConfirmScreen">
    <el-row class="title-confirm" align="middle">
      <el-col :span="24"><span class="label">{{ $t('contacts.form.title_confirm') }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('contacts.form.from') }}</span></el-col>
      <el-col :span="19"><span>{{ $t('contacts.form.from_admin') }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('contacts.form.input_labels.contact') }}</span></el-col>
      <el-col :span="19"><span>{{ categoryName }}</span></el-col>
    </el-row>
    <el-row class="row-data">
      <el-col :span="5"><span class="label">{{ $t('contacts.form.input_labels.content') }}</span></el-col>
      <el-col :span="19"><span>{{ form.content }}</span></el-col>
    </el-row>
    <form id="form" method="post" :action="urls.action">
      <input name="contact_category_id" type="hidden" :value="form.contact_category_id">
      <input name="content" type="hidden" :value="form.content">
      <input type="hidden" name="_token" :value="csrf">
    </form>
    <el-row class="btn-container">
      <el-col :span="24" class="mt-25">
       <el-button type="primary" @click="submit('form')" class="btn btn-edit btn-w157">{{ $t('contacts.form.buttons.send') }}</el-button>
       <el-button @click="backForm" class="btn btn-back btn-w157">{{ $t('back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      errors: { type: Object, required: false, default: {} },
      input: { type: Object, required: false },
      urls: { type: Object, required: true, default: {} },
      categories: { type: Object, required: true, default: {} },
    },
    data() {
      return {
        form: {
          title: '',
          content: '',
        },
        rules: {
          contact_category_id: [
            { required: true, message: this.$t('errors.required', [this.$t('contacts.form.validate.contact_category_id')]), trigger: 'blur' },
          ],
          content: [
            { required: true, message: this.$t('errors.required', [this.$t('contacts.form.validate.content')]), trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        showConfirmScreen: false
      }
    },
    methods: {
      submit() {
        document.querySelector(".el-container").classList.add("disabled");
        document.querySelector("#loader").style.display = "block";

        const form = document.getElementById("form");
        form.submit();
      },

      confirm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.showConfirmScreen = true;
          } else {
            return false;
          }
        });
      },

      backForm() {
        this.showConfirmScreen = false;
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },

      back() {
        window.location.href = this.urls.index;
      },

      validateSelect(filed) {
        this.$refs['form'].validateField(filed)
      },
    },
    created() {
      const tempData = this.input;
      this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));
    },

    computed: {
      categoryName() {
        const category = this.categories.find(element => {
          return element.id == this.form.contact_category_id;
        });

        return category ? category.name : '';
      }
    },
  }
</script>
<style lang="scss">
  .form-contact {
    .title {
      margin: 0;
    }
    .el-card__body {
      padding: 17px 38px 27px 38px;
    }

    .el-form {
      .el-input {
        width: 660px;
      }

      .el-textarea {
        width: 660px;
        .el-textarea__inner {
          height: 630px;
          padding: 25px 30px;
          letter-spacing: 1.3px;
          line-height: 29px;
        }
      }

      .image {
        width: 800px;
        height: 600px;
        margin-top: 20px;
      }

      .btn-upload {
        margin-left: 0px;
      }
    }

    .el-form-item__content {
      text-align: left !important;
    }
  }

  .confirm-contact-screen {
    .title-confirm {
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      margin-bottom: 20px;
      font-weight: 700
    }
    .el-card__body {
      padding: 28px 38px;
    }
    .btn-container {
      border-top: 1px solid #DDD8D1;
    }
  }
</style>
